<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IHDhbz/tc-custom/9780062376886.jpg?1731011562421" alt="This image is the cover for the book Barracks Thief"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Barracks Thief
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The Barracks Thief</i> is the story of three young paratroopers waiting to be shipped out to Vietnam. Brought together one sweltering afternoon to stand guard over an ammunition dump threatened by a forest fire, they discover in each other an unexpected capacity for recklessness and violence. Far from being alarmed by this discovery, they are exhilarated by it; they emerge from their common danger full of confidence in their own manhood and in the bond of friendship they have formed.</p><p>This confidence is shaken when a series of thefts occur. The author embraces the perspectives of both the betrayer and the betrayed, forcing us to participate in lives that we might otherwise condemn, and to recognize the kinship of those lives to our own.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tobias Wolff
      </h2>
      
      <p class="authorDescription body article"><P>Tobias Wolff was born in Birmingham, Alabama, and grew up in Washington State. He attended Oxford University and Stanford University, where he now teaches English and creative writing. He has received the Story Prize, both the Rea Award and PEN/Malamud Award for excellence in the short story, the <I>Los Angeles Times</I> Book Award, and the PEN/Faulkner Award.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2951b800